import $ from 'jquery';
import Backbone from 'backbone';
// import "component?js-ProductBuy"
import 'component?js-NavigationHistory';
import 'component?js-popoverTopVendor';
import 'component?js-Carousel';

const URL_ATTR = 'data-strate-url';

// See also MiniFaAsyncView and AsyncView
export default Backbone.View.extend({
  /**
   * @class StrateAsyncView
   *
   * @augments Backbone.View
   * @constructs
   *
   * ucalias : strate id
   * payload : strate params formatted as json
   *
   */
  initialize: function () {
    this._url = this.$el.attr(URL_ATTR);
    this.html = null;
    this.noContent = false;

    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);

    this.render();
  },

  onSuccess: function (data) {
    this.html = $.trim(data);

    if (!this.html) {
      this.noContent = true;
    }

    this.render();
  },

  onError: function (e) {
    // TODO log/display error;
  },

  fetch: function () {
    // TODO : refactor to its own models
    var options = {
      url: this._url,
      method: 'GET',
    };

    $.ajax(options).then(this.onSuccess, this.onError);
  },

  render: function () {
    if ($.trim(this.$el.html()) || this.noContent) {
      return this.$el;
    }

    if (this.html) {
      this.$el.html(this.html);
    } else {
      this.fetch();
    }

    return this.$el;
  },
});
